import React from "react";
import classes from "./ProductsPagination.module.css";
import { ReactComponent as ArrowLeft } from "../../../assets/arrow-left.svg";
import { ReactComponent as ArrowRight } from "../../../assets/arrow-right.svg";

const ProductsPagination = ({
  products,
  itemsPerPage,
  currPage,
  setCurrPage,
}) => {
  const pages = [];
  const totalPages = Math.ceil(products.length / itemsPerPage);
  for (let i = 1; i <= totalPages; i++) {
    pages.push(i);
  }

  const handleClickPage = (pageValue) => {
    if (pageValue < 1 || pageValue > totalPages) return;
    window.scrollTo({ top: 0, behavior: "smooth" });
    setCurrPage(pageValue);
  };

  const renderPageNumbers = () => {
    if (totalPages <= 5) {
      // Mostra todas as páginas se forem 5 ou menos
      return pages.map((pag) => (
        <button
          key={pag}
          onClick={() => handleClickPage(pag)}
          className={`${classes.pagNumber} ${+pag === +currPage ? classes.currPage : ""}`}
        >
          {pag}
        </button>
      ));
    }

    const pageNumbers = [];

    // Sempre mostra o primeiro
    pageNumbers.push(
      <button
        key={1}
        onClick={() => handleClickPage(1)}
        className={`${classes.pagNumber} ${+1 === +currPage ? classes.currPage : ""}`}
      >
        1
      </button>
    );

    if (currPage > 3) {
      pageNumbers.push(<span key="start-dots">...</span>);
    }

    // Mostra três números ao redor da página atual
    const start = Math.max(2, currPage - 1);
    const end = Math.min(totalPages - 1, currPage + 1);

    for (let i = start; i <= end; i++) {
      pageNumbers.push(
        <button
          key={i}
          onClick={() => handleClickPage(i)}
          className={`${classes.pagNumber} ${+i === +currPage ? classes.currPage : ""}`}
        >
          {i}
        </button>
      );
    }

    if (currPage < totalPages - 2) {
      pageNumbers.push(<span key="end-dots">...</span>);
    }

    // Sempre mostra o último
    pageNumbers.push(
      <button
        key={totalPages}
        onClick={() => handleClickPage(totalPages)}
        className={`${classes.pagNumber} ${+totalPages === +currPage ? classes.currPage : ""}`}
      >
        {totalPages}
      </button>
    );

    return pageNumbers;
  };

  return (
    <>
      {pages.length > 1 && (
        <nav className={classes.nav}>
          <button
            onClick={() => handleClickPage(+currPage - 1)}
            title="página anterior"
            className={classes.paginationArrow}
          >
            <ArrowLeft />
          </button>
          <div className={classes.wrapperPageNumber}>
            {renderPageNumbers()}
          </div>
          <button
            onClick={() => handleClickPage(+currPage + 1)}
            title="próxima página"
            className={classes.paginationArrow}
          >
            <ArrowRight />
          </button>
        </nav>
      )}
    </>
  );
};

export default ProductsPagination;
